module.exports = __webpack_public_path__ + "img/map3.33185972.png";